/**
 * I will let it in this package, because in the future it will probably be handled by the API,
 * not the browser.
 */
export function useDownloadAskQuery(data: Record<string, unknown>[]) {
  return () => {
    if (!data.length) return;

    const keys = Object.keys(data[0]);

    const escape = (value: unknown) => {
      if (value == null) return "";
      const str = value.toString();
      if (/[",\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`; // escape quotes by doubling them
      }
      return str;
    };

    const header = keys.map(escape).join(";");

    const values = data
      .map((line) =>
        keys
          .map((key) => escape((line as Record<string, unknown>)[key]))
          .join(";"),
      )
      .join("\n");

    const csvString = `${header}\n${values}`;
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvString], {
      type: "text/csv;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "data.csv";
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
}
